import {
    GetFilteredRestResource,
    GetRestResource,
} from "../../api/RestResourceClient";

export async function FindActiveAndValidNowByAccount(accountId) {
    const filter = {
        page: 0,
        // activeAt: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
        accountId: accountId
    };
    return await GetFilteredRestResource("api/premiumAccess/search/find-active-and-valid-now-by-account", filter);
}

export async function FindActiveByAccountId(accountId, filter) {
    return await GetFilteredRestResource("api/accounts/" + accountId + "/premiumAccess", filter);
}

export async function GetFilteredPremiumAccess(filter){
    return await GetFilteredRestResource('api/premiumAccess', filter);
}

export async function GetPremiumAccess(id) {
    return await GetRestResource('api/premiumAccess?id=' + id);
}

export async function GetAllPremiumAccessFeatures() {
    return await GetRestResource('api/premiumAccessFeatures');
}

export async function GetPremiumAccessFeatures(url) {
    return await GetRestResource(url, true);
}
